// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"B4-z","button":"C4-z","disabled":"D4-z","creditCard":"E4-z","wrapper":"F4-z"};